import { CategorizationParamsV2 } from '@scale/shared/types/params/categorization';
import React from 'react';
import { AttachmentType } from '@scale/shared/defaults';

import { makeStyles } from 'react-scale/components/design-system';

interface IMeshProps {
  assignment: {
    assignmentId: string;
    params: CategorizationParamsV2<AttachmentType.Mesh>;
  };
  id: string; // subtask ID
  instruction: string;
}

const useStyles = makeStyles({
  // Based off of css from ./website.js
  wrapper: {
    flex: '0 0 100%',
    height: '70vh',
  },
});

function Mesh(props: IMeshProps) {
  const classes = useStyles();
  const referenceWebsite = props.assignment?.params?.context?.referenceWebsite;

  return (
    <div className={classes.wrapper}>
      <h2>Mesh Annotation</h2>
      <p>
        View the mesh by opening the following link:{' '}
        <a href={`/lidarlite/?qaMeshId=${props.id}`} target="_blank" rel="noopener noreferrer">
          Open Mesh View
        </a>
      </p>

      {referenceWebsite && (
        <p>
          Open the{' '}
          <a href={referenceWebsite} target="_blank" rel="noopener noreferrer">
            reference website
          </a>{' '}
          to get an idea of what the mesh should look like
        </p>
      )}

      <p>Then, answer the questions about the mesh, and how it relates to the reference images</p>
    </div>
  );
}
export default Mesh;
